export default __webpack_public_path__ + "static/media/payment-add-paymentmethod.1ae25fd1.svg";